<ng-container *ngIf="createMultiData !== undefined">
  <div
    class="create-multi-data__create-box__body__textarea-box"
    [ngClass]="{
      'create-multi-data__error--box-border':
        createMultiData.error &&
        createMultiData.multiData.data === '' &&
        createMultiData.multiData.images.length === 0
    }"
  >
    <div
      class="create-multi-data__create-box__body__textarea-box__buttons"
      *ngIf="
        editorTypes.MathJax === createMultiData.multiData.type &&
        !createMultiData.multiData.hidden
      "
    >
      <span
        class="create-multi-data__create-box__body__textarea-box__buttons--button"
        *ngFor="let code of mathJaxCodes"
        (click)="
          addMathjaxContent(mathjaxTextarea, code.firstString, code.laststring)
        "
        >{{ code.label }}</span
      >
    </div>
    <div class="create-multi-data__create-box__body__textarea-box__head">
      <span
        (click)="toggleAccordionAction()"
        class="create-multi-data__create-box__body__textarea-box__head__type"
        >{{ createMultiData.multiData.type }}
        <mat-icon>{{
          createMultiData.multiData.hidden ? "arrow_drop_up" : "arrow_drop_down"
        }}</mat-icon></span
      >
      <img
        (click)="confirmDeleteAction(-1)"
        src="assets/crossbutton.png"
        class="create-multi-data__create-box__body__textarea-box__head__icon"
      />
    </div>
    <textarea
      class="create-multi-data__create-box__body__textarea-box__textarea"
      [ngClass]="{
        'create-multi-data__create-box__body__textarea-box__textarea--hidden':
          createMultiData.multiData.hidden ||
          createMultiData.multiData.type === 'Images',
        'create-multi-data__create-box__body__textarea-box__textarea--mathjax':
          editorTypes.MathJax === createMultiData.multiData.type
      }"
      [(ngModel)]="createMultiData.multiData.data"
      #mathjaxTextarea
    ></textarea>
    <div
      *ngIf="
        !createMultiData.multiData.hidden &&
        createMultiData.multiData.type === 'Images'
      "
      class="create-multi-data__selectFiles-container"
    >
      <button
        (click)="file.click()"
        class="create-multi-data__selectFiles-container__button"
      >
        Select Files
      </button>
      <input
        #file
        type="file"
        accept="image/*"
        (change)="uploadFileAction($event, file)"
        class="create-multi-data__file"
      />
      <div class="create-multi-data__questions">
        <div
          *ngFor="
            let image of createMultiData.multiData.images;
            let imageIndex = index
          "
          class="create-multi-data__questions__question"
        >
          <mat-icon
            class="create-multi-data__questions__question__close"
            (click)="confirmDeleteAction(imageIndex)"
            >cancel</mat-icon
          >
          {{ "Image " }}{{ imageIndex + 1 }}
        </div>
      </div>
    </div>
  </div>
</ng-container>
